<section class="landing-social">
  <div class="landing-social__inner">
    <div class="landing-social__head">
      <div>
        <h2 class="landing-social__title">{{ 'landing.social.title' | translate }}</h2>
        <p class="landing-social__sub">{{ 'landing.social.intro' | translate }}</p>
      </div>
      <div class="landing-social__actions">
        <a class="landing-social__btn landing-social__btn--ig" [href]="igUrl" target="_blank" rel="noopener noreferrer">
          {{ 'landing.social.follow_instagram' | translate }} →
        </a>
        <a class="landing-social__btn landing-social__btn--tt" [href]="ttUrl" target="_blank" rel="noopener noreferrer">
          {{ 'landing.social.follow_tiktok' | translate }} →
        </a>
        <a class="landing-social__btn landing-social__btn--fb" [href]="fbUrl" target="_blank" rel="noopener noreferrer">
          {{ 'landing.social.follow_facebook' | translate }} →
        </a>
      </div>
    </div>

    <div class="landing-social__grid">
      <a class="reel" *ngFor="let r of reels" [href]="r.url" target="_blank" rel="noopener noreferrer">
        <span class="reel__platform">{{ r.platform }}</span>
        <span class="reel__play" aria-hidden="true"><span class="reel__tri"></span></span>
        <span class="reel__overlay">
          <span class="reel__caption">{{ 'landing.social.reels.' + r.captionKey | translate }}</span>
          <span class="reel__handle">{{ r.handle }}</span>
        </span>
      </a>
    </div>
  </div>
</section>
